export async function copyTextAsync (getText) {
  const textPromise = Promise.resolve().then(() =>
    typeof getText === 'function' ? getText() : getText
  )

  const supportsAsyncClipboardItem =
    typeof ClipboardItem !== 'undefined' &&
    navigator.clipboard &&
    typeof navigator.clipboard.write === 'function'

  if (supportsAsyncClipboardItem) {
    const blobPromise = textPromise.then(
      (text) => new Blob([String(text ?? '')], { type: 'text/plain' })
    )
    await navigator.clipboard.write([
      new ClipboardItem({ 'text/plain': blobPromise })
    ])
    return textPromise
  }

  // Non-Safari fallback 
  const text = await textPromise
  await navigator.clipboard.writeText(String(text ?? ''))
  return text
}
